import React from 'react';
import { ChevronDown } from 'lucide-react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components';

export const CustomFieldSingleSelectRenderer = ({ valueFormatted, data, ...props }) => {
  const { colors } = useTheme();

  if (data?.options?.showLoader) {
    return (
      <ContentLoader
        speed={2}
        width={400}
        height={160}
        viewBox="0 0 400 160"
        backgroundColor={colors.neutral[50]}
        foregroundColor={colors.neutral[20]}
      >
        <rect x="20" y="16" rx="3" ry="3" width="80" height="8" />
      </ContentLoader>
    );
  }

  return (
    <Flex
      sx={{
        width: '100%',
        height: '100%',
        alignItems: 'center',
        px: '8px',
        cursor: 'pointer',
        '&:hover .chevron-icon, .ag-cell-focus & .chevron-icon': {
          opacity: 1,
        },
      }}
      {...props}
    >
      <Text
        flexGrow={1}
        fontSize="14px"
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          color: 'text.main',
        }}
      >
        {valueFormatted}
      </Text>
      <Flex
        className="chevron-icon"
        alignItems="center"
        flex="0 0 auto"
        sx={{
          color: 'text.subtle',
          opacity: 0,
          transition: 'opacity 0.2s ease-in-out',
        }}
      >
        <Box as={ChevronDown} width="16px" height="16px" aria-hidden="true" />
      </Flex>
    </Flex>
  );
};

CustomFieldSingleSelectRenderer.propTypes = {
  valueFormatted: PropTypes.string,
  data: PropTypes.object,
};

CustomFieldSingleSelectRenderer.defaultProps = {
  valueFormatted: '',
  data: {},
};
